<template>
  <div class="profile__invoices">
    <h2>{{$t('profile.account.recentInvoices')}}</h2>

    <div class="invoices__wrapper">
      <div v-for="(invoice, i) in items" :key="i" class="invoice">
        <span class="invoice__number">
          {{$t('profile.account.invoice')}} #{{invoice.number}}
        </span>

        <div class="invoice__content-wrapper">
          <img v-if="invoice.status === 'paid'" src="/media/inpulse-template-ac-new-a/profile/home/paid.png" alt="paid">
          <img v-else src="/media/inpulse-template-ac-new-a/profile/home/not-paid.png" alt="not paid">

          <div class="invoice__content">
            <span class="invoice__price">{{invoice.amount}}</span>
            <span class="invoice__date">{{invoice.created_at}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: [],
    },
  },
}
</script>